import { useRef } from "react";
import { useReveal } from "@/lib/animations";
import { Compass, ShieldCheck, Sparkles } from "lucide-react";
import { Aurora } from "@/components/Aurora";

const PILLARS = [
  {
    icon: Compass,
    eyebrow: "Independent",
    title: "Aligned with you — not a carrier.",
  },
  {
    icon: ShieldCheck,
    eyebrow: "Risk-protected",
    title: "A floor under your money.",
  },
  {
    icon: Sparkles,
    eyebrow: "Generational",
    title: "Plans built to outlive you.",
  },
];

export const PromiseBelt = () => {
  const ref = useRef(null);
  useReveal(ref);

  return (
    <section
      ref={ref}
      data-testid="promise-belt"
      className="relative bg-[#EEF2F7] border-y border-[#0B132B]/8 overflow-hidden"
    >
      <Aurora className="z-0" intensity="default" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-12 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            const accent =
              i === 1 ? "text-[#0a6fc2]" : i === 2 ? "text-[#0B132B]" : "text-[#29ABE2]";
            return (
              <div
                key={i}
                data-reveal
                data-reveal-delay={i * 0.08}
                data-testid={`promise-pillar-${i}`}
                className="group relative rounded-3xl bg-white/55 backdrop-blur-xl border border-white/70 shadow-xl shadow-[#0B132B]/5 p-7 md:p-9 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:bg-white/70"
              >
                <div
                  className={`inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-white/70 backdrop-blur ring-1 ring-white/80 ${accent}`}
                >
                  <Icon size={24} strokeWidth={1.75} />
                </div>
                <p
                  className={`mt-6 text-sm tracking-[0.2em] uppercase font-semibold ${accent}`}
                >
                  {p.eyebrow}
                </p>
                <h3 className="mt-3 font-heading font-black text-2xl tracking-tight text-[#0B132B] leading-tight">
                  {p.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
